import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface HeatmapChartProps {
  xData: string[];
  yData: string[];
  data: Array<[number, number, number]>;
  height?: number | string;
  loading?: boolean;
}

export function HeatmapChart({ xData, yData, data, height, loading }: HeatmapChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    grid: { left: 80, right: 20, top: 20, bottom: 60, containLabel: true },
    xAxis: { type: 'category', data: xData, splitArea: { show: true } },
    yAxis: { type: 'category', data: yData, splitArea: { show: true } },
    visualMap: { min: 0, max: Math.max(...data.map((d) => d[2]), 1), calculable: true, orient: 'horizontal', left: 'center', bottom: 0 },
    series: [{ type: 'heatmap', data, emphasis: { itemStyle: { shadowBlur: 10 } } }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
